import amazonLogo from 'assets/img/marketplaces/amazon.png';
import ebayLogo from 'assets/img/marketplaces/ebay.png';
import walmartLogo from 'assets/img/marketplaces/walmart.png';
import shipstationLogo from 'assets/img/marketplaces/ship-station.png';

export const getMarketplaceLogo = (marketplace) => {
  if (!marketplace) return '';

  switch (marketplace.toLowerCase()) {
    case 'ebay':
      return ebayLogo;
    case 'amazon':
      return amazonLogo;
    case 'walmart':
      return walmartLogo;
    case 'ship-station':
      return shipstationLogo;
    default:
      return '';
  }
};
